import React, { useState, useEffect } from "react";


const Loading = (props) => {

    return (
        <div className="loadingWrapper"
            style={{
                zIndex: 10000000000,
                display: "flex",
                position: props?.pos ? props.pos : "fixed",
                left: "0",
                top: "0",
                width: "100%",
                height: "100%",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <div>
                <img src="../../main-images/loading.gif" />
            </div>
        </div>
    )
}

export default Loading;